import Swiper from "swiper"
import { Keyboard, Navigation, Thumbs } from "swiper/modules"

let productImageSwiper
let categorySwiper
let productImageSwiperThumb

$(document).on("turbolinks:load", function () {
  // Image gallery thumbnail swiper initialization
  productImageSwiperThumb = new Swiper(".swiper-image-thumbnail", {
    spaceBetween: 8,
    slidesPerView: 8,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
      320: {
        slidesPerView: 3.5,
      },
      480: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 8,
      },
    },
  })

  // Image gallery main swiper initialization
  productImageSwiper = new Swiper(".swiper-image-gallery", {
    modules: [Navigation, Keyboard, Thumbs], // configure Swiper to use modules
    direction: "horizontal",
    loop: true,
    spaceBetween: 0,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
    thumbs: {
      swiper: productImageSwiperThumb,
    },
    on: {
      afterInit: function () {
        this.initialized = true
        updateNavigationButtons(this)
      },
      slideChange: function () {
        if (this.initialized) {
          updateNavigationButtons(this)
        }
      },
    },
  })

  // Initializes the swiper on category show pages
  categorySwiper = new Swiper(".swiper-container-category", {
    modules: [Navigation, Keyboard], // configure Swiper to use modules
    direction: "horizontal",
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 20,
    breakpoints: {
      500: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      768: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      1120: {
        slidesPerView: 6,
        slidesPerGroup: 6,
        spaceBetween: 24,
      },
    },
    loop: false, // Enable loop mode
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      addIcons: false, // the buttons carry Font Awesome icons; swiper 12 would add an svg too
    },
    speed: 1000,
  })

  // this is to hide the prev button when on the first slide
  function updateNavigationButtons(swiperInstance) {
    var $swiperPrevButton = $(".swiper-button-prev")
    if (swiperInstance.realIndex === 0) {
      $swiperPrevButton.addClass("d-none")
    } else {
      $swiperPrevButton.removeClass("d-none")
    }
  }
})

export { productImageSwiper, categorySwiper }
